import { render } from "./ModalPublish.vue?vue&type=template&id=4e854a72&scoped=true"
import script from "./ModalPublish.vue?vue&type=script&lang=js"
export * from "./ModalPublish.vue?vue&type=script&lang=js"

import "./ModalPublish.vue?vue&type=style&index=0&id=4e854a72&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e854a72"]])

export default __exports__